import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'

export default function OrderItemShouldContactStatus () {
  const inventoryItemId = useValue('id')

  function generatePath (name) {
    return ['globals.inventory.order_items', inventoryItemId, name].join('.')
  }
  const [whoShouldHandleOffset] = useEnvValue(generatePath('who_should_handle_offset'))

  const status = (whoShouldHandleOffset === 'office')
    ? (
      <Translation name='inventory.fragments.office_requests_credit_note' />
      )
    : (
      <Translation name='inventory.fragments.we_contact_supplier_about_offset' />
      )

  return (
    <UI.Text size='xs' weight='medium' color='black'>
      {status}
    </UI.Text>
  )
}
